import { QuestionTypeEditorProps } from "./types";

// numeric: optionsJson { allowDecimals, prefix }, correctAnswerJson { value, tolerance }
const NumericEditor = ({
  optionsJson,
  correctAnswerJson,
  onChange,
}: QuestionTypeEditorProps) => {
  const allowDecimals = (optionsJson.allowDecimals as boolean) ?? false;
  const prefix = (optionsJson.prefix as string) ?? "";
  const value = correctAnswerJson.value as number | undefined;
  const tolerance = (correctAnswerJson.tolerance as number | undefined) ?? 0;

  const emit = (
    nextOptions: { allowDecimals: boolean; prefix: string },
    nextAnswer: { value?: number; tolerance: number }
  ) =>
    onChange({
      optionsJson: {
        allowDecimals: nextOptions.allowDecimals,
        ...(nextOptions.prefix ? { prefix: nextOptions.prefix } : {}),
      },
      correctAnswerJson:
        nextAnswer.value === undefined || Number.isNaN(nextAnswer.value)
          ? {}
          : { value: nextAnswer.value, tolerance: nextAnswer.tolerance },
    });

  return (
    <div className="space-y-4">
      <div className="flex gap-4">
        <div className="flex-1">
          <label className="block font-medium text-burntBlack text-sm mb-1">
            Correct value
          </label>
          <input
            type="number"
            step="any"
            value={value ?? ""}
            onChange={(e) =>
              emit(
                { allowDecimals, prefix },
                {
                  value:
                    e.target.value === "" ? undefined : Number(e.target.value),
                  tolerance,
                }
              )
            }
            className="h-10 w-full px-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>
        <div className="flex-1">
          <label className="block font-medium text-burntBlack text-sm mb-1">
            Tolerance (±)
          </label>
          <input
            type="number"
            step="any"
            min={0}
            value={tolerance}
            onChange={(e) =>
              emit(
                { allowDecimals, prefix },
                { value, tolerance: Number(e.target.value) }
              )
            }
            className="h-10 w-full px-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>
      </div>
      <div className="flex items-end gap-4">
        <div className="flex-1">
          <label className="block font-medium text-burntBlack text-sm mb-1">
            Prefix (optional)
          </label>
          <input
            type="text"
            value={prefix}
            placeholder="e.g. $"
            onChange={(e) =>
              emit(
                { allowDecimals, prefix: e.target.value },
                { value, tolerance }
              )
            }
            className="h-10 w-full px-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>
        <label className="flex items-center gap-2 h-10 text-sm text-gray-700">
          <input
            type="checkbox"
            checked={allowDecimals}
            onChange={(e) =>
              emit(
                { allowDecimals: e.target.checked, prefix },
                { value, tolerance }
              )
            }
            className="h-4 w-4 accent-[#4379EE]"
          />
          Allow decimals
        </label>
      </div>
    </div>
  );
};

export default NumericEditor;
